import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=a1fc8f32&scoped=true&lang=pug"
import script from "./RegionForm.vue?vue&type=script&lang=js"
export * from "./RegionForm.vue?vue&type=script&lang=js"
import style0 from "./RegionForm.vue?vue&type=style&index=0&id=a1fc8f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fc8f32",
  null
  
)

export default component.exports